import { buildImgixUrl, buildPrivateImgixUrl } from "@/lib";
import { isImageContentType } from "@/helpers/is-image-file";
import {
  getPresignedFileUrl,
  shouldUsePresignedForPrivateDisplay
} from "@/helpers/private-file-url";
import { FileUpload } from "../../file-upload/file-upload";
import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { FileQuestionProps } from "../types";

export const FileQuestion = (props: FileQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    size,
    answerAriaLabel,
    loadingText,
    deleteText,
    replaceText,
    uploadButtonText,
    disabled,
    handleFileUpload,
    onDelete,
    deleteDisabled,
    replaceDisabled,
    answerProps,
    contentClassName,
    fileUploadDataTestIds,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps,
    isPrivateBucketEnabled = false
  } = props;

  const headerFooterProps = {
    gap,
    required,
    invalid,
    labelClassName,
    questionId,
    className,
    layoutProps,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  const fileContentType = answer?.file_content_type ?? answer?.fileContentType;
  const fileName = answer?.file_name ?? answer?.fileName;
  const isImage = isImageContentType(fileContentType, fileName);

  const presignedFileUrl = getPresignedFileUrl(answer);
  const usePresignedForDisplay =
    isPrivateBucketEnabled &&
    shouldUsePresignedForPrivateDisplay(presignedFileUrl, {
      contentType: fileContentType,
      fileName
    });
  const filePreviewSrc = isImage
    ? usePresignedForDisplay
      ? buildPrivateImgixUrl(presignedFileUrl!)
      : buildImgixUrl(answer?.value)
    : answer?.value;

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <FileUpload
          id={questionId}
          className={contentClassName}
          disabled={disabled}
          onUpload={handleFileUpload}
          onDelete={onDelete}
          deleteDisabled={deleteDisabled}
          replaceDisabled={replaceDisabled}
          fileSrc={filePreviewSrc}
          fileName={fileName}
          loadingText={loadingText}
          fileContentType={fileContentType}
          aria-label={answerAriaLabel}
          deleteText={deleteText}
          replaceText={replaceText}
          size={size}
          {...answerProps}
          fileUploadDataTestIds={fileUploadDataTestIds}
        >
          {uploadButtonText}
        </FileUpload>
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
